import React from 'react';
import actionItemsIcon from 'assets/images/ask_asper_icon.png';

const ActionItemsIcon = ({
    width = 24,
    height = 24,
    className,
}: {
    width?: number;
    height?: number;
    className?: string;
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            aria-hidden
        >
            <image href={actionItemsIcon} width="24" height="24" preserveAspectRatio="xMidYMid meet" />
        </svg>
    );
};

export default ActionItemsIcon;
